import { UncontrolledSelect } from '@/components/UncontrolledForm'
import { TooltipCell } from '../ToolTipCell'

const MultipleSelectCell = ({ getValue, row: { index }, column: { id }, table, options, extraDisable = false }) => {
  const isDisabled = table.options.meta?.disabled || extraDisable
  const currentValues = Array.isArray(getValue()) ? getValue() : []

  if (isDisabled) {
    const selectedLabels = options
      ?.filter((option) => currentValues.includes(option.value))
      .map((option) => option.label)
      .join(', ')

    return <TooltipCell text={selectedLabels || '(-)'} />
  }

  const onChange = (newValue) => {
    const selectedValues = Array.isArray(newValue)
      ? newValue.map((option) => option?.value ?? '').filter((value) => value !== '')
      : []

    table.options.meta?.updateData(index, id, selectedValues)
  }

  return <UncontrolledSelect value={currentValues} onChange={onChange} options={options || []} isMulti />
}

export default MultipleSelectCell
